import router from "@/router/index"
import store from "@/store/index"
import homeApi from '@/api/home'
import Cookies from 'js-cookie'
import { ElMessage } from 'element-plus'

// 添加一个导航计数器，用于检测并防止循环重定向
let redirectCount = 0;
const REDIRECT_MAX = 3; // 最大允许的重定向次数
let lastPath = '';
let lastTime = 0;
let visitedPaths = []; // 记录最近访问的路径，用于检测循环

router.beforeEach(async (to, from, next) => {
    console.log('路由守卫: 从', from.path, '到', to.path, '查询参数:', to.query);
    
    // 检测短时间内相同路径的重定向（优化：只在真正需要时检测）
    const now = Date.now();
    // 只有在路径相同且时间间隔很短时才认为是可能的循环
    if (to.path === lastPath && now - lastTime < 500) {
        redirectCount++;
        console.warn(`检测到可能的循环重定向: ${redirectCount}次`);
        
        // 如果重定向次数超过阈值，允许继续但记录警告
        if (redirectCount > REDIRECT_MAX) {
            console.error('检测到循环重定向，但允许继续导航');
            redirectCount = 0; // 重置计数器
            visitedPaths = []; // 重置访问路径记录
            // 不中断导航，允许继续
        }
    } else {
        // 不同路径或时间间隔足够，重置计数器
        redirectCount = 0;
    }
    
    // 更新最后访问路径和时间
    lastPath = to.path;
    lastTime = now;
    
    // 记录访问路径，检测循环
    visitedPaths.push(to.path);
    if (visitedPaths.length > 10) {
        visitedPaths.shift(); // 最多保留10条记录
    }
    
    // 获取token (从所有可能的存储位置获取)
    const token = window.sessionStorage.getItem('token') || 
                  window.localStorage.getItem('token') || 
                  Cookies.get('token');
    
    console.log('当前token:', token ? `${token.substring(0, 15)}...` : 'null');
    
    // 检查URL中是否有token参数（企业微信回调）
    if (to.query.token) {
        console.log('URL中检测到token参数（企业微信回调）');
        const urlToken = to.query.token;
        const urlUserId = to.query.user_id;
        
        // 保存token到所有存储位置
        window.sessionStorage.setItem('token', urlToken);
        window.localStorage.setItem('token', urlToken);
        Cookies.set('token', urlToken, { expires: 1 });
        
        // 如果有user_id，也保存
        if (urlUserId) {
            window.sessionStorage.setItem('userId', urlUserId);
            window.localStorage.setItem('userId', urlUserId);
            console.log('保存user_id:', urlUserId);
        }
        
        // 如果有token和user_id，说明是已绑定用户，需要获取用户信息
        if (urlToken && urlUserId) {
            console.log('检测到企业微信回调，已绑定用户，开始获取用户信息');
            // 重定向到没有token参数的相同路径，但保留user_id用于后续获取用户信息
            const query = { ...to.query };
            delete query.token;
            // user_id保留在query中，后续路由守卫会使用它
            return next({ 
                path: to.path, 
                query, 
                replace: true 
            });
        } else {
            // 只有token没有user_id，清除token参数后继续
            const query = { ...to.query };
            delete query.token;
            return next({ 
                path: to.path, 
                query, 
                replace: true 
            });
        }
    }
    
    // 白名单路由（含员工积分商城，不走管理员登录）
    const whiteList = ['/login', '/bind', '/reset-password-page', '/points'];
    
    // 员工端：有员工 token 或访问 /points，不强制管理员 userSerializer
    const employeeToken =
        window.sessionStorage.getItem('points_employee_token') ||
        window.localStorage.getItem('points_employee_token');
    if (to.path === '/points' || to.meta?.pointsEmployee) {
        console.log('员工积分商城路由，跳过管理端鉴权');
        return next();
    }
    
    if (token) {
        console.log('已登录状态');
        
        // 如果已登录但没有用户信息，先获取用户信息
        const userInfo = window.sessionStorage.getItem('userSerializer') || 
                         window.localStorage.getItem('userSerializer');
        
        if (!userInfo) {
            console.log('没有用户信息，开始获取');
            
            try {
                // 检查URL中是否有user_id参数（企业微信回调）
                const urlUserId = to.query.user_id || window.sessionStorage.getItem('userId');
                console.log('获取用户信息，使用user_id:', urlUserId);
                
                // 调用获取用户信息的接口，传递user_id
                const res = await store.dispatch('getUserInfo', urlUserId);
                console.log('获取用户信息结果:', res);
                
                if (res.code === 200) {
                    console.log('用户信息获取成功');
                    
                    // 如果是登录页，重定向到首页
                    if (to.path === '/login') {
                        console.log('当前是登录页，重定向到首页');
                        next({ path: '/' });
                    } else {
                        console.log('继续导航到', to.path);
                        // 确保路由已添加完成后再导航
                        next({ ...to, replace: true });
                    }
                } else {
                    // 获取用户信息失败，清除token
                    console.error('获取用户信息失败:', res.msg);
                    ElMessage.error(res.msg || '登录已过期，请重新登录');
                    
                    // 清除所有存储位置的token
                    window.sessionStorage.removeItem('token');
                    window.localStorage.removeItem('token');
                    Cookies.remove('token');
                    
                    // 重定向到登录页
                    next({ path: '/login', query: { redirect: to.fullPath } });
                }
            } catch (error) {
                // 出错处理
                console.error('获取用户信息出错:', error);
                ElMessage.error('登录已过期，请重新登录');
                
                // 清除所有存储位置的token
                window.sessionStorage.removeItem('token');
                window.localStorage.removeItem('token');
                Cookies.remove('token');
                
                // 重定向到登录页
                next({ path: '/login', query: { redirect: to.fullPath } });
            }
        } else {
            // 有用户信息，可以继续导航
            console.log('已有用户信息');
            
            // 如果请求的是登录页，重定向到首页
            if (to.path === '/login') {
                console.log('当前是登录页，重定向到首页');
                next({ path: '/' });
            } else {
                console.log('继续导航到', to.path);
                next();
            }
        }
    } else {
        // 没有token
        console.log('未登录状态');
        
        if (whiteList.includes(to.path) || employeeToken && to.path.startsWith('/points')) {
            // 白名单页面，直接通过
            console.log('访问白名单页面', to.path);
            next();
        } else {
            // 非白名单页面，重定向到登录页
            console.log('未登录，重定向到登录页');
            next({ path: '/login', query: { redirect: to.fullPath } });
        }
    }
});

// 动态绑定路由
const bindRoute = (menuList) => {
    try {
        console.log('开始绑定路由, 菜单数量:', menuList.length);
        let newRoutes = router.options.routes;
        let routesAdded = false;
        
        menuList.forEach(menu => {
            if (menu.children) {
                menu.children.forEach(m => {
                    let route = menuToRoute(m, menu.name);
                    if (route) {
                        // 检查路由是否已经存在
                        const routeExists = router.hasRoute(route.name);
                        if (!routeExists) {
                            console.log('添加新路由:', route.path);
                            if (newRoutes[0] && newRoutes[0].children) {
                                newRoutes[0].children.push(route);
                                routesAdded = true;
                            }
                        }
                    }
                });
            }
        });
        
        // 只有在有新路由添加时才重新添加
        if (routesAdded) {
            // 重新添加到路由
            newRoutes.forEach(route => {
                if (!router.hasRoute(route.name)) {
                    router.addRoute(route);
                }
            });
            
            console.log('路由绑定完成');
        }
    } catch (error) {
        console.error('绑定路由出错:', error);
    }
};

// 菜单对象转成路由对象
const menuToRoute = (menu, parentName) => {
    if (!menu.component) {
        return null;
    } else {
        let route = {
            name: menu.name,
            path: menu.path,
            meta: {
                parentName: parentName,
                title: menu.title || menu.name
            }
        };
        
        try {
            route.component = () => import('@/views/' + menu.component + '.vue');
        } catch (error) {
            console.error(`无法加载组件: @/views/${menu.component}.vue`, error);
            return null;
        }
        
        return route;
    }
};